export default "__VITE_ASSET__b873ae4c__"